import { TypographyPropsVariantOverrides, Components } from '@mui/material-hidden';
import { textVariants, transformVariants } from './variants';

export const MuiTypography: Components['MuiTypography'] = {
  variants: [
    ...(transformVariants<keyof TypographyPropsVariantOverrides>() || []),
    {
      props: { variant: 'h1' },
      style: {
        '&&&': {
          ...textVariants.titilliumWeb24,
        },
      },
    },
    {
      props: { variant: 'h5' },
      style: textVariants.titilliumWeb20,
    },
    {
      props: { variant: 'body1' },
      style: textVariants.titilliumWebSemiBold12,
    },
    {
      props: { variant: 'subtitle2' },
      style: textVariants.titilliumWebSemiBold14,
    },
  ],
};
